import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext({ lang: "fr", setLang: () => {} });

export function LanguageProvider({ children, defaultLang = "fr" }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("site_lang") || defaultLang;
    } catch {
      return defaultLang;
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("site_lang", l);
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
